import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export const LoanNotFullySubmittedCard = () => {
  return (
    <>
      <Alert severity="info">
        <Typography>
          Your loan is not yet fully submitted! Please continue to the next page for submission.
        </Typography>
      </Alert>
    </>
  );
};